<template>
  <div class="text-center text-4xl font-bold">
    {{ formattedValue }}
  </div>
</template>

<script setup lang="ts">
const { formatToMerchantCurrencyString } = useCurrency()
const props = defineProps<{ value: number }>()

const formattedValue = computed(() =>
  formatToMerchantCurrencyString(props.value)
)
</script>
